import "./text-area.css";

const TextArea = (props) => {
   return (
      <textarea className="text-area" {...props} />
   );
};

export default TextArea;
